import React from "react";
import clsx from "clsx";
import {makeStyles, Typography} from "@material-ui/core";

const useTypographyStyles = makeStyles(theme => {
    return {
        time: {
            fontWeight: theme.typography.fontWeightBold,
            lineHeight: "normal",
        },
        timeSpecial: {
            fontSize: "0.75rem",
        },
        timeSmall: {
            fontSize: "0.9rem",
        },
        timeLarge: {
            fontSize: "1.5rem",
        },
    }
})

export const BingoCountdownTypography = (props) => {
    const classes = useTypographyStyles();

    return (
        <Typography
            className={clsx(classes.time, {[classes.timeLarge]: !props.small && !props.mini}, {[classes.timeSmall]: props.small}, {[classes.timeSpecial]: props.mini})}>
            {props.children}
        </Typography>
    );
};